import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { FaChevronUp, FaFacebookF, FaInstagram, FaYoutube, FaLinkedinIn } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  const [isVisible, setIsVisible] = useState(false);

  // Scroll visibility handler
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-section">
            <h3 className="footer-title">WeCare EHS</h3>
            <p className="footer-description">
              Professional EHS training solutions with multi-language support
              and customized learning programs.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="section-heading">Quick Links</h4>
            <div className="footer-nav">
              <Link to="/about" className="nav-link">About Us</Link>
              <Link to="/training" className="nav-link">Courses</Link>
              <Link to="/feedback" className="nav-link">Feedback</Link>
              <Link to="/contact" className="nav-link">Contact</Link>
              <Link to="/privacy" className="nav-link">Privacy</Link>
            </div>
          </div>

          <div className="footer-section">
            <h4 className="section-heading">Connect</h4>
            <div className="social-container">
              <a href="https://m.facebook.com/profile.php?id=61574926660055" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaFacebookF />
              </a>
              <a href="https://www.instagram.com/wecareehs?utm_source=qr&igsh=cnc2ZXV2bGRhcHE2" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaInstagram />
              </a>
              <a href="https://youtube.com/@wecareehs?feature=shared" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaYoutube />
              </a>
              <a href="https://www.linkedin.com/in/ehswecare" className="social-link" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn />
              </a>
            </div>
            {/* New Section for GST and Udyam Numbers */}
            <div className="footer-gst-udyam-section" style={{ marginTop: "1rem", color: "#ff8c00", textAlign: "right" }}>
              <h4>Registration Numbers</h4>
              <p>GST Number: 27NYIPK7993B1ZP</p>
              <p>Udyam Number: UDYAM-MH-33-0388318</p>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="copyright">&copy; 2026 WeCare EHS. All rights reserved.</p>
        </div>

        {isVisible && (
          <button
            className="footer-scroll-to-top-btn"
            onClick={scrollToTop}
            aria-label="Scroll to top"
          >
            <FaChevronUp />
          </button>
        )}
      </div>
    </footer>
  );
};

export default Footer;